import { render, staticRenderFns } from "./DynamicPopup.vue?vue&type=template&id=56e8c802"
import script from "./DynamicPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicPopup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports